import React, { useMemo } from 'react';
import { NavLink }        from 'react-router-dom';
import { reduxForm }      from 'redux-form';
import { useTranslation } from 'react-i18next';

import { validate } from '../actions/validate';

import RenderButton            from '../../buttons/base/RenderButton';
import { RenderPhoneField }    from '../../fields/redux/RenderPhoneField';
import { RenderTextField }     from '../../fields/redux/RenderTextField';
import { useCommon }           from '../../../providers/common';
import { RenderCheckboxField } from '../../fields/redux/RenderCheckboxField';

const DealerRequestForm = (props) => {
  const {
          closeModal,
          handleSubmit,
          submitForm,
          valid,
        } = props;

  const { pages } = useCommon();
  const { t }     = useTranslation();

  const getAgreementPage = useMemo(() => {
    const agreementPage = pages.find(page => page.template === 'policy-personal-data');
    return agreementPage && `/${agreementPage.urlKey}`;
  }, [pages]);

  return (
    <form
      name={'DealerRequestForm'}
      noValidate={true}
      method={'post'}
      onSubmit={(event) => submitForm(event, handleSubmit, valid)}
    >
      <RenderTextField
        autoComplete={'off'}
        placeholder={`${t('client_name')}`}
        name={'name'}
        required
      />
      <RenderPhoneField
        autoComplete={'off'}
        hiddenMask
        placeholder={`${t('client_phone')}`}
        name={'phone'}
        required
      />
      <div className={'agreement'}>
        <RenderCheckboxField
          autoComplete={'off'}
          label={
            <span className={'agreement_wrapper'}>{t('сlient_agreement')}{' '}
              <NavLink
                to={getAgreementPage}
                onClick={closeModal}
              >
                {t('client_agreement_processingOfPersonalData')}
              </NavLink>
            </span>}
          name={'agreement'}
        />
      </div>

      <div className={'buttonsContainer'}>
        <RenderButton label={t('btn_cancel')} action={closeModal} />
        <RenderButton
          className={'fill'}
          label={t('client_sendRequest')}
          type={'submit'}
        />
      </div>
    </form>);
};

export default reduxForm({
  form:         'DealerRequestForm',
  validate,
  onSubmitFail: (errors, dispatch) => {
  },
})(DealerRequestForm);
